<template>
    <div class="panel">
        <transition name="fade" appear>
            <img :src="require('@/assets/images/panel_graphics/magic.png')" alt="">
        </transition>
    </div>
</template>

<script>

    export default {
        name: 'Magic_panel',
        created: function () {
            CodeBaby.jQuery('.no-nlp:hidden').show();
            CodeBaby.jQuery('.codebaby-stt-button:hidden').show();
        }
    }
</script>
<style scoped lang="stylus">
.panel
    text-align: center
    background: none !important
    .fade-enter-active, .fade-leave-active 
        transition: opacity 1s
    .fade-enter, .fade-leave-to
        opacity: 0
</style>